// web/src/console/sections/UserDetailSection.tsx
import type { JSX } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { consoleApi } from "../../lib/consoleApi";
import { useAsync } from "../useAsync";
import { fmtRelative, formatAnnotationPayload } from "../format";
export function UserDetailSection(): JSX.Element {
  const { userId = "" } = useParams();
  const navigate = useNavigate();
  const { data, loading, error, reload } = useAsync(() => consoleApi.fetchUser(userId), [userId]);
  if (loading) return <div className="cc-skeleton" style={{ height: 200 }} />;
  if (error || !data) return <div className="cc-empty">加载失败。 <button className="cc-back" onClick={reload}>重试</button></div>;
  const u = data.user;
  return (
    <>
      <button className="cc-back" onClick={() => navigate("/admin/users")}>全部用户</button>
      <div className="cc-card" style={{ marginTop: 12 }}>
        <div className="cc-card-title">用户</div>
        <div>{u?.username ?? userId} · {u?.tenant ?? "—"} · {u?.currentConversations ?? 0} 会话 · {u?.messages ?? 0} 消息 · 差评 {u?.thumbsDown ?? 0}</div>
      </div>
      <div className="cc-card" style={{ marginTop: 12 }}>
        <div className="cc-card-title">会话</div>
        {data.conversations.length === 0 ? <div className="cc-empty">无</div> :
          <table className="cc-table"><tbody>
            {data.conversations.map((c) => (
              <tr key={c.sessionId}><td>{c.title}</td><td>{c.turnCount} 轮</td><td>{c.handedOff ? "已转人工" : ""}</td><td>{fmtRelative(c.updatedAt)}</td></tr>
            ))}
          </tbody></table>}
      </div>
      <div className="cc-card" style={{ marginTop: 12 }}>
        <div className="cc-card-title">标注（评分 / 反馈）</div>
        {data.annotations.length === 0 ? <div className="cc-empty">无</div> :
          <table className="cc-table"><tbody>
            {data.annotations.map((a) => (
              <tr key={a.id}><td>{a.kind}</td><td>{formatAnnotationPayload(a.payload)}</td><td>{a.status}</td><td>{fmtRelative(a.createdAt)}</td></tr>
            ))}
          </tbody></table>}
      </div>
      <div className="cc-card" style={{ marginTop: 12 }}>
        <div className="cc-card-title">最近事件</div>
        {data.events.length === 0 ? <div className="cc-empty">无</div> :
          <table className="cc-table"><tbody>
            {data.events.map((e) => (
              <tr key={e.id}><td>{e.eventType}</td><td>{e.method} {e.path}</td><td>{e.status ?? ""}</td><td>{fmtRelative(e.createdAt)}</td></tr>
            ))}
          </tbody></table>}
      </div>
    </>
  );
}
